module.exports = __webpack_public_path__ + "static/media/oxygen_mask.675e7bec.jpg";